import { Page, Text, View, Image } from "@react-pdf/renderer";
import "../styles/Font";
import { useTranslation } from "react-i18next";
import { WasteQualityLegend } from "../wasteQuality/WasteQualityLegend";
import { ImageComponent } from "../wasteQuality/ImageComponent";
import MaterialDistributionBlock from "./MaterialDistributionBlock";
import SortingErrorsDistributionBlock from "./SortingErrorsDistributionBlock";
import HistoryCycleBlock from "./HistoryCycleBlock";
import {
  formattedDate,
  formattedTime,
} from "../../formatted/FormattedDateAndTime";
import userIcon from "../../../static/assets/user.png";

export const FillingCyclePdfContent = ({
  data,
  timeLine,
  collectionFillingLevel,
  numberOfAnomaly,
  chartImageUrl,
  cycleChartImgUrl,
  numberOfStars,
  contaminants,
  numberOfPackmat,
  clientRegisteredWeight,
  materialChartImgData,
  numberOfObjects,
  comments,
  oneImage,
}) => {
  const { t } = useTranslation();

  const getDrawableContoursCount = (item) => {
    const wasteObjectsList = item?.wasteObjectsList;
    if (!Array.isArray(wasteObjectsList)) return 0;
    return wasteObjectsList.filter(
      (object) =>
        Boolean(object?.cls) &&
        Array.isArray(object?.points_konva) &&
        object.points_konva.length > 0,
    ).length;
  };

  const hasNoDrawableContours = (item) => getDrawableContoursCount(item) === 0;

  const groupedData = [];
  for (let i = 0; i < data.length; i += 2) {
    groupedData.push(data.slice(i, i + 2));
  }

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  return (
    <>
      <Page size="A4">
        <View
          fixed
          style={{ height: 20, backgroundColor: "#0F265C", width: "100%" }}
        />
        <Image
          source={require("../../../static/assets/Akanthas-logo-RVB.png")}
          style={{ width: 111, height: 40, marginTop: 4, marginBottom: 6 }}
        />
        <View style={{ flexDirection: "column", paddingTop: 0, marginTop: -4 }}>
          {timeLine.activatedSortingErrorOption && (
            <SortingErrorsDistributionBlock
              numberOfAnomaly={numberOfAnomaly}
              contaminants={contaminants}
              numberOfStars={numberOfStars}
              chartImageUrl={chartImageUrl}
            />
          )}
          <MaterialDistributionBlock
            numberOfObjects={numberOfObjects}
            materialChartImgData={materialChartImgData}
          />
          {!timeLine.activatedSortingErrorOption && !oneImage ? (
            <HistoryCycleBlock
              collectionFillingLevel={collectionFillingLevel}
              clientRegisteredWeight={clientRegisteredWeight}
              numberOfPackmat={numberOfPackmat}
              cycleChartImgUrl={cycleChartImgUrl}
            />
          ) : (
            ""
          )}
        </View>
      </Page>
      {timeLine.activatedSortingErrorOption && !oneImage ? (
        <Page size="A4">
          <View
            fixed
            style={{ height: 20, backgroundColor: "#0F265C", width: "100%" }}
          />
          <Image
            source={require("../../../static/assets/Akanthas-logo-RVB.png")}
            style={{ width: 111, height: 40, marginVertical: 10 }}
          />
          <View style={{ flexDirection: "column" }}>
            <HistoryCycleBlock
              collectionFillingLevel={collectionFillingLevel}
              clientRegisteredWeight={clientRegisteredWeight}
              numberOfPackmat={numberOfPackmat}
              cycleChartImgUrl={cycleChartImgUrl}
            />
          </View>
        </Page>
      ) : (
        ""
      )}

      {!oneImage &&
        groupedData.length > 0 &&
        groupedData
          .flat()
          .reduce((acc, item, index) => {
            if (index % 6 === 0) acc.push([]);
            acc[acc.length - 1].push(item);
            return acc;
          }, [])
          .map((group, pageIndex) =>
            group.length > 0 ? (
              <Page key={pageIndex} size="A4">
                {/* Bande bleue en haut */}
                <View
                  fixed
                  style={{
                    height: 20,
                    backgroundColor: "#0F265C",
                    width: "100%",
                  }}
                />
                <Image
                  source={require("../../../static/assets/Akanthas-logo-RVB.png")}
                  style={{ width: 111, height: 40, marginLeft: 10 }}
                />
                {/* Contenu avec padding */}
                <View style={{ paddingHorizontal: 20, paddingTop: 20 }}>
                  {Array.from({ length: 3 }).map((_, rowIndex) => (
                    <View
                      key={rowIndex}
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginBottom: 20,
                      }}
                    >
                      {group
                        .slice(rowIndex * 2, rowIndex * 2 + 2)
                        .map((item, subIndex) => (
                          <View
                            key={subIndex}
                            style={{
                              width: "48%",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <ImageComponent
                              data={item}
                              drawMaterial={false}
                              height={180}
                              width={170}
                            />
                            <Text
                              style={{
                                fontSize: 10,
                                marginTop: 10,
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                            >
                              {`${t("Level")} ${item.filling_level}%`}
                            </Text>
                          </View>
                        ))}
                    </View>
                  ))}
                </View>
              </Page>
            ) : null,
          )}
      {data.length > 0 &&
        chunkArray(data, 3)
          .filter((group) => group.length > 0)
          .map((group, pageIndex) => (
            <Page key={pageIndex} size="A4">
              <View
                fixed
                style={{
                  height: 20,
                  backgroundColor: "#0F265C",
                  width: "100%",
                }}
              />
              <Image
                source={require("../../../static/assets/Akanthas-logo-RVB.png")}
                style={{ width: 111, height: 40, marginLeft: 10 }}
              />
              {!oneImage ? (
                <View style={{ paddingHorizontal: 20, paddingTop: 10 }}>
                  {group.map((item, index) => (
                    <View
                      key={index}
                      style={{
                        flexDirection: "column",
                        marginBottom: 5,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: 5,
                        }}
                      >
                        {[false, true].map((drawMaterial, subIndex) => (
                          <View
                            key={subIndex}
                            style={{
                              width: "48%",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <ImageComponent
                              data={item}
                              drawMaterial={drawMaterial}
                              height={180}
                              width={170}
                            />
                          </View>
                        ))}
                      </View>
                      <WasteQualityLegend
                        data={item}
                        direction={"row"}
                        marginTop={5}
                      />
                      {hasNoDrawableContours(item) && (
                        <Text
                          style={{
                            fontSize: 10,
                            marginTop: 4,
                            textAlign: "left",
                            color: "#6B7280",
                          }}
                        >
                          {t("No sorting errors detected")}
                        </Text>
                      )}
                    </View>
                  ))}
                </View>
              ) : (
                group.map((item, index) => (
                  <View
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      padding: 20,
                      height: "79%",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <View
                      style={{
                        flex: 7.7,
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 20,
                      }}
                    >
                      <ImageComponent data={item} drawMaterial={true} />
                      <ImageComponent data={item} drawMaterial={false} />
                    </View>
                    <View style={{ flex: 2.3 }}>
                      <WasteQualityLegend data={item} />
                      {hasNoDrawableContours(item) && (
                        <Text
                          style={{
                            fontSize: 10,
                            marginTop: 4,
                            color: "#6B7280",
                          }}
                        >
                          {t("No sorting errors detected")}
                        </Text>
                      )}
                    </View>
                  </View>
                ))
              )}
            </Page>
          ))}
      {comments.length > 0 && (
        <Page size="A4">
          <View
            fixed
            style={{
              height: 20,
              backgroundColor: "#0F265C",
              width: "100%",
            }}
          />
          <Image
            source={require("../../../static/assets/Akanthas-logo-RVB.png")}
            style={{ width: 111, height: 40, marginLeft: 10 }}
          />
          <View
            style={{ height: "79%", backgroundColor: "#ffffff", padding: 10 }}
          >
            {comments.reverse().map((item, index) => (
              <View
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 8,
                  marginTop: 10,
                }}
              >
                <View
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    borderRadius: 50,
                    backgroundColor: "#00A7A6",
                    height: 25,
                    width: 25,
                    overflow: "hidden",
                    color: "#e5e7eb",
                  }}
                >
                  <Image
                    src={userIcon}
                    style={{
                      height: 10,
                      width: 10,
                      objectFit: "cover",
                    }}
                  />
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#e5e7eb",
                    borderRadius: 6,
                    paddingLeft: 12,
                    paddingRight: 12,
                    paddingTop: 8,
                    paddingBottom: 8,
                    width: "100%",
                  }}
                >
                  <View
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        gap: 8,
                      }}
                    >
                      <Text style={{ color: "#00A6A7", fontSize: 10 }}>
                        {item?.author.firstName} {item?.author.lastName}
                      </Text>
                      <Text style={{ color: "#6B7280", fontSize: 10 }}>
                        {formattedDate(item.time, t)} -{" "}
                        {formattedTime(item.time)}
                      </Text>
                    </View>
                  </View>
                  <Text
                    style={{
                      color: "#6B7280",
                      marginTop: 8,
                      fontSize: 10,
                    }}
                  >
                    {item.text}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </Page>
      )}
    </>
  );
};
